var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBroadcast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5667 0L14.3688 1.19783C16.684 3.51302 16.684 7.42672 14.3688 9.74191L15.5667 10.9397C18.5316 7.97481 18.5316 2.96493 15.5667 0ZM11.8275 3.7392C12.3069 4.21867 12.5721 4.83368 12.5721 5.46987C12.5721 6.10606 12.3069 6.72107 11.8275 7.20054L13.0253 8.39837C13.825 7.59954 14.2663 6.55842 14.2663 5.46987C14.2663 4.38132 13.825 3.3402 13.0253 2.54137L11.8275 3.7392ZM4.13051 1.19783L2.93268 0C-0.032248 2.96493 -0.032248 7.97481 2.93268 10.9397L4.13051 9.74191C1.81533 7.42672 1.81533 3.51302 4.13051 1.19783Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.05061 2.54126C4.25092 3.3401 3.80957 4.38121 3.80957 5.46976C3.80957 6.55831 4.25092 7.59943 5.05061 8.39826L6.24844 7.20043C5.76896 6.72096 5.50382 6.10595 5.50382 5.46976C5.50382 4.83357 5.76896 4.21856 6.24844 3.73909L5.05061 2.54126ZM10.7323 5.25798C10.7323 4.80864 10.5538 4.3777 10.236 4.05997C9.91829 3.74224 9.48735 3.56374 9.03801 3.56374C8.58867 3.56374 8.15773 3.74224 7.84 4.05997C7.52227 4.3777 7.34377 4.80864 7.34377 5.25798C7.34338 5.53761 7.41246 5.81296 7.54479 6.05929C7.67713 6.30562 7.86858 6.51523 8.10194 6.66929L7.34546 14.9999H10.7306L9.97408 6.66844C10.4315 6.36517 10.7323 5.84673 10.7323 5.25798Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcast);
export default __webpack_public_path__ + "static/media/Broadcast.18a8b4e119cff0259a20689c550d63a7.svg";
export { ForwardRef as ReactComponent };